import React, { PropsWithChildren } from 'react';

import { useIconsByContext } from '@/hooks/useIconsByContext';
import { useIsDesktop } from '@/hooks/useIsDesktop';
import { PropsWithClassName } from '@/types/index';
import { EnumContextGDT } from '@/types/team';
import { cn } from '@/utils';

interface ContextData {
  title?: string;
  subtitle?: string | any;
  widthICon?: boolean;
}

interface Props extends PropsWithChildren, PropsWithClassName, ContextData {
  context?: EnumContextGDT;
}

export const MainHome = React.memo(
  ({
    context = EnumContextGDT.FriendTournament,
    children,
    className,
    title,
    subtitle,
    widthICon = true,
  }: Props) => {
    const { isDesktop } = useIsDesktop();
    const src = useIconsByContext({ context });

    return (
      <div>
        <div className={cn('flex', className)}>
          {src?.icon && widthICon && isDesktop && (
            <figure className="max-w-8 w-full mr-5 mb-6">
              <img alt={title} className="w-full" src={src?.icon} />
            </figure>
          )}
          <div>
            {isDesktop && title && (
              <h1 className="text-black font-bold text-2xl">{title}</h1>
            )}
            {subtitle && (
              <p className="font-medium lg:font-semibold text-sm mt-5 text-gdt-gray-2">
                {subtitle}
              </p>
            )}
          </div>
        </div>
        {children}
      </div>
    );
  }
);

MainHome.displayName = 'MainHome';
